/* Lazy loads the vault film. The source is only attached once the element is
   near the viewport, so the mp4 is not downloaded on page load. Mirrors the
   approach in virtual-appointment-media.js but kept separate so a change to one
   page cannot break the other. */
(function () {
  var vids = document.querySelectorAll('video[data-vault-lazy]');
  if (!vids.length) return;

  function load(v) {
    if (v.dataset.vaultLoaded) return;
    v.dataset.vaultLoaded = '1';
    var src = v.getAttribute('data-src');
    if (src && !v.querySelector('source')) {
      var s = document.createElement('source');
      s.src = src;
      s.type = 'video/mp4';
      v.appendChild(s);
    }
    v.load();
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* autoplay blocked, poster stays */ });
  }

  if (!('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(vids, load);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { load(e.target); io.unobserve(e.target); }
    });
  }, { rootMargin: '300px 0px' });

  Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
})();
